<div class="h-full">
  <input
    #documentInput
    [accept]="allowedDocumentFileTypes()"
    [multiple]="false"
    (change)="onDocumentSelected($event)"
    class="hidden"
    type="file"
  />
  <flx-resources-page
    [showAddNew]="canEdit"
    [showSearchInput]="true"
    (searchQueryChange)="onSearchQueryChange($event)"
    (addNew)="documentInput.click()"
    class="h-full"
    pageTitle="Document Intelligence"
    searchInputPlaceholder="Search by document name"
  >
    <ng-container ngProjectAs="[flxResourcesPageBody]">
      <flx-resources-grid
        [tableDef]="documentsTableDef"
        [inputGridOptions]="gridOptions()"
        [uniqueKeys]="['id']"
        (gridReady)="onGridReady($event)"
        class="h-full"
        emptyMsg="No documents available."
        data-testId="document-intelligence-table"
      />
    </ng-container>
  </flx-resources-page>
</div>

<p-menu
  #actionsMenu
  [appendTo]="'body'"
  [popup]="true"
/>
